import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import Portfolio from "@/pages/Portfolio";
import Recommendations from "@/pages/Recommendations";
import ArticleDetail from "@/pages/ArticleDetail";
import Pricing from "@/pages/Pricing";
import News from "@/pages/News";
import AIChat from "@/pages/AIChat";
import ChartAnalyzer from "@/pages/ChartAnalyzer";
import Gems from "@/pages/Gems";
import Academie from "@/pages/Academie";
import ModuleView from "@/pages/ModuleView";
import LessonViewer from "@/pages/LessonViewer";
import DailyLesson from "@/pages/DailyLesson";
import TradingSimulator from "@/pages/TradingSimulator";
import ProAnalysis from "@/pages/ProAnalysis";
import Checkout from "@/pages/Checkout";
import VIPAdmin from "@/pages/VIPAdmin";
import VIPPage from "@/pages/VIPPage";
import Disclaimer from "@/pages/Disclaimer";
import Terms from "@/pages/Terms";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import SubscriptionPolicy from "@/pages/SubscriptionPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Contact from "@/pages/Contact";
import DeleteAccount from "@/pages/DeleteAccount";
import AppLanding from "@/pages/AppLanding";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { TierProvider } from "@/context/TierContext";

function ProtectedRoute({ children }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/" />;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <TierProvider>
          <BrowserRouter>
            <div className="App">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/article/:id" element={<ArticleDetail />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/subscription-policy" element={<SubscriptionPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/news" element={<ProtectedRoute><News /></ProtectedRoute>} />
                <Route path="/chat" element={<ProtectedRoute><AIChat /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
                <Route path="/recommendations" element={<ProtectedRoute><Recommendations /></ProtectedRoute>} />
                <Route path="/chart-analyzer" element={<ProtectedRoute><ChartAnalyzer /></ProtectedRoute>} />
                <Route path="/gems" element={<ProtectedRoute><Gems /></ProtectedRoute>} />
                <Route path="/academie" element={<ProtectedRoute><Academie /></ProtectedRoute>} />
                <Route path="/academie/module/:moduleId" element={<ProtectedRoute><ModuleView /></ProtectedRoute>} />
                <Route path="/academie/module/:moduleId/lesson/:lessonId" element={<ProtectedRoute><LessonViewer /></ProtectedRoute>} />
                <Route path="/academie/daily" element={<ProtectedRoute><DailyLesson /></ProtectedRoute>} />
                <Route path="/simulator" element={<ProtectedRoute><TradingSimulator /></ProtectedRoute>} />
                <Route path="/pro-analysis" element={<ProtectedRoute><ProAnalysis /></ProtectedRoute>} />
                <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                <Route path="/vip-admin" element={<ProtectedRoute><VIPAdmin /></ProtectedRoute>} />
              <Route path="/vip" element={<VIPPage />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/app" element={<AppLanding />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
              <Toaster />
            </div>
          </BrowserRouter>
        </TierProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
